import { LOGO_URL } from "@/lib/clinic";

export { LOGO_URL };

export const Logo = ({ className = "h-7", invert = false }) => (
  <img
    src={LOGO_URL}
    alt="MAB"
    data-testid="brand-logo"
    className={`${className} w-auto object-contain select-none ${invert ? "invert" : ""}`}
    draggable={false}
  />
);
